<article>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <app-title-with-back>{{ dashboardTitle }}</app-title-with-back>
      </div>
      <div class="col-md-12 options-container">
        <ng-container *ngFor="let link of menuOptions">
          <a [href]="link.url" class="m-square-link m-4">
            <div class="square-link-icon d-flex justify-content-center align-items-center">
              <img class="standar-icon" [src]="link.icon || defaultIcon" [alt]="'Icono de ' + link.name" />
            </div>
            <div class="text">{{ link.name }}</div>
          </a>
        </ng-container>
      </div>
    </div>
  </div>
</article>
